import authorizationService from '@/core/auth/authorization-service'
import _ from 'lodash'
import store from '@/store'
import constants from '@/core/constants'

function hasFeature(name) {
  const unit = getUnit()
  const featureRoles = _.get(unit, [name, 'pickedKeys'], [])
  return _.intersection(authorizationService.getUserRoles(), featureRoles).length > 0
}

function isSparkProUser() {
  return authorizationService.getClaim(constants.customClaims.isSparkProUser)
}

function getUnit() {
  const currentErrand = store.getters.currentErrand
  const companies = store.getters.companies
  const claimCompanyKey = authorizationService.getClaim(constants.customClaims.companyKey)
  if(claimCompanyKey) {
    return companies[claimCompanyKey]
  }
  if(currentErrand) {
    return companies[store.getters.currentErrand.company_key]
  }
}

export default { hasFeature, isSparkProUser }
